import { Typewriter } from "react-simple-typewriter";

const RotatingText = () => {
    return (
        <h2 className="text-sm sm:text-2xl font-semibold text-[#F5C400] mb-4 text-center">
            <Typewriter
                words={[
                    "Manage Tasks Properly",
                    "Assign Work Effortlessly",
                    "Track Progress in Real-Time",
                    "Stay Updated with Instant Alerts",
                ]}
                loop={0}          // Infinite
                cursor
                cursorStyle="|"
                typeSpeed={60}
                deleteSpeed={40}
                delaySpeed={1300}
            />
        </h2>
    );
};

export default RotatingText;
